import {
  type MutationFunction,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import useModal from 'ui/partials/Modal/useModal';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import partialConstants from 'ui/partials/utils/constants';

import { LEAD_FORM } from '../forms/schema';
import c from '../utils/constants';

export interface Payload extends LEAD_FORM {
  id: string;
  photoUrl?: string;
}

export default function useUpdateLead() {
  const queryClient = useQueryClient();
  const { hideModal } = useModal();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  const mutationFn: MutationFunction<any, any> = async (payload) => {
    const api = new Api(args);

    const { id, ...rest } = payload;

    const data = await api.patch(
      await withAcl({
        account: {
          url: `api/v1/contacts/leads/${id}`,
          payload: rest,
        },
        admin: {
          url: `api/v2/accounts/${accountId}/users/${accountUserId}/contacts/leads/${id}`,
          payload: rest,
        },
      }),
    );

    return data;
  };

  return useMutation({
    mutationFn,
    // successData: { data: Lead }, { id, companyId }
    onSuccess: (_, { id, companyId }) => {
      // queryClient.setQueryData([c.LEADS, id, c.DETAILS], () => {

      //   return successData?.data;
      // });
      queryClient.invalidateQueries({
        queryKey: [c.LEADS, {}],
      });
      queryClient.invalidateQueries({
        queryKey: [c.COMPANIES, {}],
      });
      queryClient.invalidateQueries({
        queryKey: [c.LOGS, id],
      });
      queryClient.invalidateQueries({
        queryKey: [c.LEADS, id, c.DETAILS],
      });
      queryClient.invalidateQueries({
        queryKey: [partialConstants.TAGS],
      });

      if (companyId !== undefined) {
        queryClient.invalidateQueries({
          queryKey: [c.COMPANIES],
        });
      }

      hideModal();
      toastSuccess('Successfully updated lead');
    },
  });
}

interface _Payload {
  leadId: string[];
}

export function useUpdateLeadOnly(id: string) {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useMutation({
    mutationFn: async (payload: _Payload) => {
      const api = new Api(args);

      const data = await api.patch(
        await withAcl({
          account: {
            url: `/api/v1/contacts/companies/${id}/references/leads`,
            payload,
          },
          admin: {
            // eslint-disable-next-line max-len
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/contacts/companies/${id}/references/leads`,
            payload,
          },
        }),
      );

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [c.COMPANIES, id, c.DETAILS] });
      queryClient.invalidateQueries({ queryKey: [c.LOGS, id] });

      toastSuccess('Successfully updated contact.');
    },
  });
}
